import React, { useEffect, useState } from 'react'
import { IStoreState, useAppDispatch, useAppSelector } from '../../../../redux';
import { useOutletContext } from '../../../../providers';
import { fetchOutletSingleLayoutAsync, ITablesLayout } from '../../../../redux/tables';
import { ControlledCustomSelect } from '../../../../Components/formComponents';
import { ISelectOption } from '../../../../constants/types';


interface ILayoutTableSelectorProps {
    layout: string,
    disabled?: boolean
    value: string
    onChange: (val: ISelectOption) => void,
    error?: string
}
export const LayoutTableSelector: React.FC<ILayoutTableSelectorProps> = ({ layout, disabled, value, onChange, error }) => {
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()
    const dispatch = useAppDispatch();

    const {
        data: singleObjectData,
    } = useAppSelector((storeState: IStoreState) => storeState.tables.single_tables_layout);
    const [tables, setTables] = useState<ITablesLayout["tables"]>([]);


    useEffect(() => {
        if (!layout) return
        dispatch(fetchOutletSingleLayoutAsync(layout))
    }, [layout])


    useEffect(() => {
        setTables(singleObjectData.tables.filter((table) => table.data.type !== "line"))
    }, [singleObjectData])



    return (
        <>
            <ControlledCustomSelect
                label="Table Number"
                name="table_no"
                fullWidth
                disabled={disabled}
                options={tables.map((tbl) => ({ label: tbl.data.table_number, value: tbl.id as string }))}
                placeholder="Select Layout"
                value={value}
                onChange={(evt) => {
                    const newValue = singleObjectData.tables.find((tbl) => tbl.id === evt.target.value)
                    if (newValue) onChange({ label: newValue.data.table_number.toString(), value: newValue.id as string })
                }}
                error={error}
            />

        </>
    )
}
